import axios from "axios";

// Prefer same-origin at runtime so one bundle works across preview URL,
// emergent.host deployment, and custom domains (jetsetless.com).
// The env var remains as a fallback for SSR / build-time tooling.
const runtimeOrigin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : "";
const BACKEND_URL = runtimeOrigin || process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});
